import styled from '@emotion/styled';
import { DESKTOP_TOP_HEIGHT } from '../../constants';
import { mobileOnly } from '../../utils/sharedStyles';

export const userMenuClass = 'user-menu-wrapper';
export const desktopBrandList = 'desktop-brandList';
export const StyledDiv = styled.div`
  @media (${mobileOnly}) {
    display: none;
  }
  background: var(--podium-cds-color-bg-secondary);
  position: relative;
  z-index: 3;

  .${desktopBrandList} {
    height: ${DESKTOP_TOP_HEIGHT}px;
    display: flex;
  }

  ${props =>
    props.isSearchOpen &&
    `
      z-index: 1;
  `}
`;
